import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "next-themes";
import "@/index.css";
import "@/light-contrast.css";
import "@/search-fields.css";
import axios from "axios";
import { getOrderOriginHeader, initializeOrderOriginTracking } from "@/lib/orderOrigin";

try {
  initializeOrderOriginTracking();
} catch (error) {
  console.warn("Não foi possível iniciar o rastreamento de origem.", error);
}

function isFirstPartyApiRequest(config) {
  try {
    const backendBase = process.env.REACT_APP_BACKEND_URL || window.location.origin;
    const apiRoot = new URL("/api", backendBase);
    const requestUrl = new URL(config.url || "", config.baseURL || window.location.origin);
    return requestUrl.origin === apiRoot.origin
      && (requestUrl.pathname === apiRoot.pathname || requestUrl.pathname.startsWith(`${apiRoot.pathname}/`));
  } catch {
    return false;
  }
}

axios.interceptors.request.use((config) => {
  if (isFirstPartyApiRequest(config)) {
    config.headers = config.headers || {};
    config.headers["X-LOTQ-Origin"] = getOrderOriginHeader();
  }
  return config;
});

let RootComponent;
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_CONTRAST_PREVIEW === "true") {
  RootComponent = require("./staging/ContrastPreview").default;
} else if (process.env.REACT_APP_CASHBACK_LIVE_PREVIEW === "true") {
  const preview = require("./staging/CashbackLivePreview");
  preview.installCashbackLivePreview();
  RootComponent = preview.default;
} else if (process.env.REACT_APP_CASHBACK_PREVIEW === "true") {
  const preview = require("./staging/CashbackPreview");
  preview.installCashbackPreview();
  RootComponent = preview.default;
} else {
  RootComponent = require("@/App").default;
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={true} storageKey="lotq-theme">
      <RootComponent />
    </ThemeProvider>
  </React.StrictMode>,
);
